import { render, staticRenderFns } from "./ProfileHeader.vue?vue&type=template&id=07835fc8&scoped=true"
import script from "./ProfileHeader.vue?vue&type=script&lang=js"
export * from "./ProfileHeader.vue?vue&type=script&lang=js"
import style0 from "./ProfileHeader.vue?vue&type=style&index=0&id=07835fc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07835fc8",
  null
  
)

export default component.exports